import axios from 'axios';

export default {
  delete(invoiceId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId)
      .then(results=>{
        return results.data;
      })
  },
  void(invoiceId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"?action=VOID" )
      .then(results=>{
        return results.data;
      })
  },
  send(invoiceId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"?action=SEND" )
      .then(results=>{
        return results.data;
      })
  },
  fetchInvoicePaidByCreditNotes (creditNoteId) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/invoices/credit-notes/"+creditNoteId)
      .then(results=>{
        return results.data;
      })
  },
  deleteInvoiceCreditNote(invoiceId, creditNoteId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/credit-notes/"+creditNoteId)
      .then(results=>{
        return results.data;
      })
  },
  previewInvoiceNotification(invoiceId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/email", {params})
      .then(results=>{
        return results.data;
      })
  },
  sendInvoiceNotification(invoiceId, contacts, content, language, attachment){
    let data = {};
    data.contacts = contacts
    data.content = content;
    data.language=language;
    data.attachment=attachment;
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/email", data)
      .then(results=>{
        return results.data;
      })
  },
  post(invoice){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices", invoice)
    .then(results=>{
        return results.data;
      })
  },
  put(invoiceId, invoice){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId, invoice)
      .then(results=>{
        return results.data;
      })
  },
  postV2(invoice){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/invoices", invoice)
      .then(results=>{
        return results.data;
      })
  },
  putV2(invoiceId, invoice){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/invoices/"+invoiceId, invoice)
      .then(results=>{
        return results.data;
      })
  },
  fetchInvoices(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices", {params})
      .then(results=>{
        return results.data;
      })
  },
  fetchPublicInvoices(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/invoices", {params})
      .then(results=>{
        return results.data;
      })
  },
  get(invoiceId){
    // return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId)
     return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/invoices/"+invoiceId)
      .then(results=>{
        return results.data;
      })
  },
  fetchInvoiceTerms(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/terms")
      .then(results=>{
        return results.data;
      })
  },
  downloadInvoiceReport(invoiceId, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/report";

    return axios({
          url: url,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
           const blob = new Blob([response.data], { type: "application/pdf" });
          

           const url = window.URL.createObjectURL(blob);
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', filename+'.pdf'); //or any other extension
           console.log('link : ', link);
           document.body.appendChild(link);
           link.click();
           document.body.removeChild(link);
           window.URL.revokeObjectURL(url);
        });
  },
  downloadQuickbooksExtractInvoicesCSV (filters, filename) {
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/invoices/reports/QUICKBOOKS_EXPORT";
    let params  = filters;
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename+'.csv'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  downloadExtractInvoicesCSV(invoicesIds, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices";
    let params  ={
      format : 'CSV',
      id:invoicesIds,
      paging:'no'
    }
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename+'.csv'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  deleteFile(invoiceId, id){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/files/"+id)
      .then(results=>{
        return results.data;
      })
  },
  calculateInvoiceV2(invoice){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/invoices/calculate", invoice)
      .then(results=>{
        return results.data;
      })
  },
  calculateInvoice(invoice){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/calculate", invoice)
      .then(results=>{
        return results.data;
      })
  },
  applyCreditNotes(invoiceId, creditNotes){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/credit-notes", creditNotes)
      .then(results=>{
        return results.data;
      })
  },
  convertSalesOrdersToInvoice(params){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/invoices", null, {params})
      .then(results=>{
        return results.data;
      })
  },
  convertPurchaseOrderToInvoice(params){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/invoices", null, {params})
      .then(results=>{
        return results.data;
      })
  }

}
